<template>
  <Teleport to="body">
    <Transition name="modal" appear>
      <div v-if="open" class="fixed inset-0 z-50 flex items-center justify-center p-4" @click.self="$emit('cancel')">
        <div class="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
        <div class="relative bg-white dark:bg-[#1C2128] rounded-2xl shadow-2xl border border-gray-100 dark:border-gray-700 max-w-sm w-full p-6 animate-in">
          <div class="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4" :class="danger ? 'bg-red-50 dark:bg-red-900/20' : 'bg-blue-50 dark:bg-blue-900/20'">
            <svg class="w-6 h-6" :class="danger ? 'text-red-500' : 'text-blue-500'" fill="none" stroke="currentColor" stroke-width="1.75" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"/>
            </svg>
          </div>

          <h3 class="text-base font-semibold text-gray-900 dark:text-white text-center mb-1.5">{{ title }}</h3>
          <p class="text-sm text-gray-500 dark:text-gray-400 text-center" :class="$slots.subject ? 'mb-4' : 'mb-6'">{{ message }}</p>

          <!-- Shows the exact entity being acted on (logo + name), so there's
               no ambiguity about which row a hover-triggered click applied to. -->
          <div v-if="$slots.subject" class="flex items-center justify-center gap-2 mb-6 px-3 py-2 bg-gray-50 dark:bg-[#161b22] border border-gray-200 dark:border-gray-700 rounded-lg">
            <slot name="subject" />
          </div>

          <div class="flex gap-3">
            <button @click="$emit('cancel')" type="button" :disabled="saving"
              class="flex-1 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 rounded-lg transition-colors disabled:opacity-60 cursor-pointer">
              {{ cancelText }}
            </button>
            <button @click="$emit('confirm')" type="button" :disabled="saving"
              class="flex-1 inline-flex items-center justify-center gap-1.5 py-2.5 text-sm font-medium text-white rounded-lg transition-colors disabled:opacity-60 cursor-pointer"
              :class="danger ? 'bg-red-600 hover:bg-red-700' : 'bg-blue-600 hover:bg-blue-700'">
              <svg v-if="saving" class="w-3.5 h-3.5 animate-spin" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
              </svg>
              {{ confirmText }}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
defineProps({
  open: { type: Boolean, default: false },
  title: { type: String, required: true },
  message: { type: String, default: 'This action cannot be undone.' },
  confirmText: { type: String, default: 'Delete' },
  cancelText: { type: String, default: 'Cancel' },
  danger: { type: Boolean, default: true },
  saving: { type: Boolean, default: false },
})

defineEmits(['confirm', 'cancel'])
</script>
